// Parallel types for each set category
// print_run: null means unnumbered, number means numbered to that amount, 1 means 1/1

export const BASE_PARALLELS = [
  { id: 'refractor', name: 'Refractor', print_run: null, color: '#c8d8f0' },
  { id: 'aqua', name: 'Aqua Refractor', print_run: 199, color: '#00e5ff' },
  { id: 'aqua-lava', name: 'Aqua Lava Refractor', print_run: 175, color: '#00bcd4' },
  { id: 'blue', name: 'Blue Refractor', print_run: 150, color: '#2979ff' },
  { id: 'wave', name: 'Wave Refractor', print_run: 99, color: '#00b0ff' },
  { id: 'logofractor-77', name: 'Logofractor', print_run: 77, color: '#c8d8f0' },
  { id: 'prism', name: 'Prism Refractor', print_run: 75, color: '#e040fb' },
  { id: 'mojo', name: 'Mojo Refractor', print_run: 50, color: '#ff6d00' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'xfractor', name: 'X-Fractor', print_run: 10, color: '#76ff03' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'red-logofractor', name: 'Red Logofractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

export const INSERT_PARALLELS = [
  { id: 'aqua', name: 'Aqua Refractor', print_run: 199, color: '#00e5ff' },
  { id: 'aqua-lava', name: 'Aqua Lava Refractor', print_run: 175, color: '#00bcd4' },
  { id: 'blue', name: 'Blue Refractor', print_run: 150, color: '#2979ff' },
  { id: 'wave', name: 'Wave Refractor', print_run: 99, color: '#00b0ff' },
  { id: 'logofractor-77', name: 'Logofractor', print_run: 77, color: '#c8d8f0' },
  { id: 'prism', name: 'Prism Refractor', print_run: 75, color: '#e040fb' },
  { id: 'mojo', name: 'Mojo Refractor', print_run: 50, color: '#ff6d00' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'xfractor', name: 'X-Fractor', print_run: 10, color: '#76ff03' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

export const AUTO_PARALLELS = [
  { id: 'wave', name: 'Wave Refractor', print_run: 99, color: '#00b0ff' },
  { id: 'mojo', name: 'Mojo Refractor', print_run: 50, color: '#ff6d00' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Set-derived supplement. These parallel ids appear in src/sets/*.js (the
// authoritative per-set checklists) but are NOT in the curated ladders above,
// so without them the marketplace/sold feed can't resolve a parallel's display
// name or print run and falls back to the raw id + "#serial" (e.g. it showed
// "green-shimmer · #039" instead of "Green Shimmer Refractor · 39/199").
// Generated from the set files; values match each set's own rendering.
// PAR_MAP is built first-win, so the curated ladders above take precedence and
// this list only fills gaps — no existing behavior changes.
export const SET_PARALLELS = [
  { id: 'atomic', name: 'Atomic Refractor', print_run: 150, color: '#00bcd4' },
  { id: 'black-and-white-shimmer-refractor', name: 'Black & White Shimmer Refractor', print_run: null, color: '#e8e8ec' },
  { id: 'black-foil', name: 'Black Foil', print_run: 1, color: '#a8a8b4' },
  { id: 'black-pulsar-refractor', name: 'Black Pulsar Refractor', print_run: 10, color: '#a8a8b4' },
  { id: 'blue-pulsar-refractor', name: 'Blue Pulsar Refractor', print_run: null, color: '#5f8dff' },
  { id: 'blue-ray-wave', name: 'Blue Ray Wave Refractor', print_run: 175, color: '#2979ff' },
  { id: 'blue-red', name: 'Blue/Red Lava Refractor', print_run: 99, color: '#ff6b6b' },
  { id: 'dathomir-red-refractor', name: 'Dathomir Red Refractor', print_run: 5, color: '#ff5d5d' },
  { id: 'dathomir-red-wave-refractor', name: 'Dathomir Red Wave Refractor', print_run: 5, color: '#ff9090' },
  { id: 'gold', name: 'Gold Refractor', print_run: 50, color: '#f0c040' },
  { id: 'gold-foil', name: 'Gold Foil', print_run: 1, color: '#f0c040' },
  { id: 'gold-mini-diamonds-refractor', name: 'Gold Mini Diamonds Refractor', print_run: 50, color: '#f3d985' },
  { id: 'gold-refractor', name: 'Gold Refractor', print_run: 50, color: '#f0c040' },
  { id: 'green', name: 'Green', print_run: 150, color: '#00e676' },
  { id: 'green-shimmer', name: 'Green Shimmer Refractor', print_run: 199, color: '#00e87a' },
  { id: 'hoth-ice-blue-frozenfractor', name: 'Hoth Ice Blue Frozenfractor', print_run: 5, color: '#a8d8ff' },
  { id: 'kamino-purple-refractor', name: 'Kamino Purple Refractor', print_run: 199, color: '#bb8ce4' },
  { id: 'kashyyyk-green-refractor', name: 'Kashyyyk Green Refractor', print_run: 99, color: '#5fd35f' },
  { id: 'magenta', name: 'Magenta RayWave Refractor', print_run: 10, color: '#e91e63' },
  { id: 'mini-diamond-refractor', name: 'Mini Diamonds Refractor', print_run: 50, color: '#c8cad8' },
  { id: 'mojo-refractor', name: 'Mojo Refractor', print_run: 25, color: '#ff9d52' },
  { id: 'mustafar-black-lava-refractor', name: 'Mustafar Black Lava Refractor', print_run: 10, color: '#c98f82' },
  { id: 'mustafar-black-refractor', name: 'Mustafar Black Refractor', print_run: 10, color: '#9c9c96' },
  { id: 'orange-pulsar-refractor', name: 'Orange Pulsar Refractor', print_run: 25, color: '#ff9d52' },
  { id: 'orange-refractor', name: 'Orange Refractor', print_run: 25, color: '#ff9d52' },
  { id: 'plate-black', name: 'Printing Plate Black', print_run: 1, color: '#808080' },
  { id: 'plate-blk', name: 'Printing Plate Black', print_run: 1, color: '#808080' },
  { id: 'plate-cyan', name: 'Printing Plate Cyan', print_run: 1, color: '#00e5ff' },
  { id: 'plate-mag', name: 'Printing Plate Magenta', print_run: 1, color: '#e91e63' },
  { id: 'plate-magenta', name: 'Printing Plate Magenta', print_run: 1, color: '#e91e63' },
  { id: 'plate-yel', name: 'Printing Plate Yellow', print_run: 1, color: '#ffee58' },
  { id: 'plate-yellow', name: 'Printing Plate Yellow', print_run: 1, color: '#ffee58' },
  { id: 'prism-refractor', name: 'Prism Refractor', print_run: null, color: '#d4d1e8' },
  { id: 'purple', name: 'Purple', print_run: 99, color: '#b060ff' },
  { id: 'purple-pulsar-refractor', name: 'Purple Pulsar Refractor', print_run: null, color: '#cb7dff' },
  { id: 'rainbow', name: 'Rainbow Refractor', print_run: 199, color: '#e0c8ff' },
  { id: 'rainbow-refractor', name: 'Rainbow Refractor', print_run: null, color: '#e7c3e2' },
  { id: 'raywave-refractor', name: 'RayWave Refractor', print_run: null, color: '#6cef4d' },
  { id: 'rebel-orange-refractor', name: 'Rebel Orange Refractor', print_run: 25, color: '#ff8a3d' },
  { id: 'rebel-orange-wave-refractor', name: 'Rebel Orange Wave Refractor', print_run: 25, color: '#ffb072' },
  { id: 'red-pulsar-refractor', name: 'Red Pulsar Refractor', print_run: 5, color: '#ff806b' },
  { id: 'red-refractor', name: 'Red Refractor', print_run: 5, color: '#ff5d5d' },
  { id: 'silver-foil', name: 'Silver Foil', print_run: 1, color: '#d4d4dc' },
  { id: 'skywalker-blue-refractor', name: 'Skywalker Blue Refractor', print_run: 150, color: '#7ba2ff' },
  { id: 'wave-refractor', name: 'Wave Refractor', print_run: 5, color: '#5b9dff' },
  { id: 'x-fractor', name: 'X-Fractor', print_run: 10, color: '#84e04a' },
  { id: 'yellow-lazer', name: 'Yellow Lazer Refractor', print_run: 75, color: '#ffee58' },
];

export function getParallelsForType(type) {
  switch (type) {
    case 'base': return BASE_PARALLELS;
    case 'insert': return INSERT_PARALLELS;
    case 'auto': return AUTO_PARALLELS;
    default: return [];
  }
}

export function parallelKey(setId, cardN, parallelId) {
  return `${setId}__${cardN}__parallel__${parallelId}`;
}
